var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.org.bankAccounts),function(bankaccount,index){return _c('div',{key:bankaccount.id},[_c('bank-acct-dtl-view',{attrs:{"bankaccount":bankaccount,"index":index,"is-nzbn":_vm.org.nzbn != null}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }